import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';

interface ErrorHelperProps {
  message: string;
}

const ErrorHelper: React.FC<ErrorHelperProps> = ({ message }) => {
  if (!message) return null;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <ErrorOutlineIcon fontSize="inherit" color="error" />
      {message}
    </span>
  );
};

export default ErrorHelper;
